import { ImageBreakpointSrcSetSizes, ImageSrcSetSizes, resolveBreakpointMinWidth } from '../Image.type';

export const breakpointsToSrcSet = (breakpointSpecs: ImageBreakpointSrcSetSizes): ImageSrcSetSizes => {
  return [...breakpointSpecs]
    .sort((a, b) => resolveBreakpointMinWidth(b[0]) - resolveBreakpointMinWidth(a[0]))
    .map(([key, layoutWidth]) => {
      const minWidth = resolveBreakpointMinWidth(key);

      return [minWidth > 0 ? `(min-width: ${minWidth}px)` : '', layoutWidth] as ImageSrcSetSizes[number];
    });
};
